// import React, { useState, useMemo } from "react";
// import { Table } from "antd";
// import { Tooltip } from "antd";

// // Pure Component using React.memo
// export const Tables = React.memo(
//   ({
//     data,
//     headers,
//     pageSize,
//     current,
//     total,
//     onChange,
//     onSort,
//     sortBy,
//     sortOrder,
//   }) => {
//     const columns = useMemo(() => {
//       return headers.map((header) => ({
//         title: <div className="text-base font-normal text-center">{header.label}</div>,
//         dataIndex: header.key,
//         key: header.key,
//         align: header.textAlign || 'center',
//         sorter: false, // Disable Ant Design's default sorting behavior
//         onHeaderCell: () => ({
//           onClick: onSort,
//         }),
//         render: (text) => (
//           <div
//             className="text-sm  font-light truncate max-w-[150px] cursor-pointer text-center"
//             title={text} // Show full text on hover
//             style={{
//               whiteSpace: "nowrap",
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//               textAlign:"center"
//             }}
//           >
//             {text?.length > 14 ? (
//               <Tooltip title={text}> {text.substring(0, 14)}...</Tooltip>
//             ) : (
//               text
//             )}
//           </div>
//         ),
//       }));
//     }, [headers, sortBy, sortOrder]);

//     return (
//       <div style={{ width: "100%", backgroundColor: "#fff",textAlign:"center" }}>
//         <Table
//           dataSource={data}
//           columns={columns}
//           pagination={{
//             current: current,
//             pageSize: pageSize,
//             total: total,
//             onChange: onChange,
//             showSizeChanger: false,
//             showTotal: false,
//             style: {
//               marginRight: "40px",
//               textAlign:"center"
//             },
//           }}
//         />
//       </div>
//     );
//   }
// );
import React, { useState, useMemo } from "react";
import { Table } from "antd";
import { Tooltip } from "antd";

// Pure Component using React.memo
export const Tables = React.memo(
  ({
    data,
    headers,
    pageSize,
    current,
    total,
    onChange,
    onSort,
    sortBy,
    sortOrder,
    emptyText,
  }) => {
    const columns = useMemo(() => {
      return headers.map((header) => ({
        title: <div className="text-base font-normal text-center">{header.label}</div>,
        dataIndex: header.key,
        key: header.key,
        align: 'center', // ✅ Yeh add karo - Body data center mein
        sorter: false,
        onHeaderCell: () => ({
          onClick: onSort,
        }),
        render: (text) => (
          <div
            className="text-sm font-light  cursor-pointer  max-w-full  justify-center text-center flex items-center "
          >
            {
            text?.length > 14 ? (
              <div
                className="text-sm font-light items-center max-w-[150px] flex justify-center text-center  max-w-[120px] sm:max-w-[150px] md:max-w-[200px]"
                style={{
                  textAlign: "center",
                  wordWrap: "break-word",
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                }}
              >
                {text}
              </div>
            ) : (
              <span className="truncate inline-block max-w-full text-center">{text}</span>
            )}
          </div>
        )

      }));
    }, [headers, sortBy, sortOrder]);

    return (
      <div style={{ width: "100%", backgroundColor: "#fff" }}>
        <Table
          dataSource={data}
          columns={columns}
          locale={emptyText ? { emptyText } : undefined}
          pagination={
            data && data.length > 0
              ? {
                  current: current,
                  pageSize: pageSize,
                  total: total,
                  onChange: onChange,
                  showSizeChanger: false,
                  showTotal: false,
                  style: {
                    marginRight: "40px",
                    borderRadius: "10px",
                  },
                }
              : false
          }
        />
      </div>
    );
  }
);